<template>
  <div>
  <q-table
      title="Doações de fontes externas"
      :data="donationsValues"
      :columns="columns"
      row-key="id"
      :loading="isLoading"
    >

    <template v-slot:top="props">
      <div class="row col-11 q-col-gutter-xs">
        <div class="col-11 text-center text-h3">Doações de fontes externas</div>
      </div>
      <!-- 
      <div class="col-1 text-center">
        <q-btn color="bg-purple-10" outline icon="add" @click="openModal(value, false)"></q-btn>
      </div>
      -->
    </template>

    
  </q-table>

  
  </div>
</template>

<script>
import { setupAxios } from '../views/microfrontend/setupAxios';
import { getDonationFromSources } from '../views/microfrontend/apiClient';
import { numberToReal } from '../helpers';
export default {
  name: 'DonationFromSource',
  components: { },
  data () {
    return {
      donationsValues: [],
      columns: [
        {
          name: 'id',
          label: 'ID',
          align: 'left',
          field: 'id'
        },
        {
          name: 'created_at',
          label: 'Data da atualização',
          align: 'left',
          field: 'created_at'
        },
        {
          name: 'donator_name',
          label: 'Nome do doador',
          align: 'left',
          field: 'donator_name'
        },
        {
          name: 'donator_document',
          label: 'CPF(Doador)',
          align: 'left',
          field: 'donator_document'
        },
        {
          name: 'amount',
          label: 'Valor',
          align: 'left',
          field: 'amount',
        },       
        {
          name: 'recurring',
          label: 'Doação recorrente?',
          align: 'left',
          field: 'recurring',
          format: (r) => {
            return r ? "SIM" : "NÃO";
          }
        },
      ],
      isLoading: true
    };
  },
  async mounted () {
    this.axios = setupAxios();
    this.donationsValues = (await getDonationFromSources(this.axios)).data;
    console.log("this.donationsValues", this.donationsValues)
    this.isLoading = false;
  },
  methods: {
    
  }
};
</script>

<style scoped>

</style>

